import { createTheme } from "@mantine/core";
import { tokens } from "./tokens";

/**
 * Mantine theme customization
 * @see https://mantine.dev/theming/theme-object/
 */
export const mantineTheme = createTheme({
  primaryColor: 'dark',
  defaultRadius: 'md',

  // Custom font family
  fontFamily: tokens.typography.fontFamily,
  fontFamilyMonospace: tokens.typography.fontFamilyMonospace,

  // Custom font sizes
  fontSizes: {
    xs: '0.75rem',
    sm: '1rem',
    md: '1.1rem',
    lg: '1.2rem',
    xl: '1.4rem',
  },

  // Component defaults
  components: {
    TextInput: {
      defaultProps: {
        size: 'md',
      },
    },
    Textarea: {
      defaultProps: {
        size: 'md',
      },
    },
    Button: {
      defaultProps: {
        size: 'md',
      },
    },
  },
});
